
import { useParams } from 'react-router-dom';
import { BannersFormState } from '../../../context/banners/BannersFormState';
import { Form } from './form';

export const BannersFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Banner" : "Crear Banner";
  return (
    <BannersFormState>
        <br />
        <Form title={title} />
    </BannersFormState>
  );
};
